// @flow
import React from "react";
import FaqIconSvg from "../../../svg/qicons/faqIcon.svg";
import type { IconSizes } from "../../../types/Icons";
import getSizeClass from "../../../helpers/getIconSizeClassname";

import styles from "./faqIcon.module.scss";

type Props = {
  size: IconSizes
};

const FaqIcon = ({ size = "1x" }: Props) => {
  const sizeClass = getSizeClass(size);

  return <FaqIconSvg className={`${styles.base} ${sizeClass}`} />;
};

export default FaqIcon;
